import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainBidderAlert } from 'features/globalSetup/api/types/domainBidderAlert'
import { DomainBidderSlice } from '../types'
import { DomainBidderSliceDTO } from './types'

export const fromDTO = (from: DomainBidderSliceDTO) =>
  mapDTO<DomainBidderSliceDTO, DomainBidderSlice>({ from }).transform(
    (domainBidderDTO: DomainBidderSliceDTO): DomainBidderSlice => {
      const {
        csEnabled,
        fieldAlerts,
        id,
        priority,
        s2sEnabled,
        updatedAt,
        workspaceBidder: {
          bidder: { name, s2sAvailable },
          bidderCode: code,
          id: workspaceBidderId,
          priority: workspaceBidderPriority,
          status,
        },
      } = domainBidderDTO

      return {
        alerts: alertsFromDTO<DomainBidderAlert>(fieldAlerts),
        code,
        csEnabled,
        id,
        name,
        priority,
        s2sAvailable: s2sAvailable,
        s2sEnabled,
        status,
        updatedAt: new Date(updatedAt),
        workspaceBidderId,
        workspaceBidderPriority,
      }
    },
  )
